(function () {
  'use strict';
  if (window.GBCart) return;

  function sectionIds() {
    return Array.prototype.slice
      .call(document.querySelectorAll('cart-items-component'))
      .map(function (el) {
        return el.dataset.sectionId;
      })
      .filter(Boolean);
  }

  function formatMoney(amount) {
    var n = amount.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var fmt = window.GBMoneyFormat;
    if (typeof fmt === 'string' && fmt.indexOf('{{') !== -1) return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
    return '£' + n;
  }

  window.GBCart = {
    money: function (pence) {
      return formatMoney(pence / 100);
    },
    moneyFloat: function (pounds) {
      return formatMoney(pounds);
    },

    add: function (items, opts) {
      opts = opts || {};
      var lines = Array.isArray(items) ? items : [items];
      var trigger = opts.trigger || null;
      if (trigger && trigger.dataset.gbCartBusy) return Promise.resolve({ ok: false, busy: true });
      if (trigger) {
        trigger.dataset.gbCartBusy = '1';
        trigger.setAttribute('aria-disabled', 'true');
      }
      var restoreBusy =
        trigger && window.GBUI && window.GBUI.busy ? window.GBUI.busy(trigger, trigger.dataset.busyLabel || 'Adding\u2026') : null;
      if (opts.errorEl) opts.errorEl.hidden = true;
      var ids = sectionIds();
      var body = { items: lines };
      if (ids.length > 0) body.sections = ids.join(',');
      function unlatch() {
        if (restoreBusy) restoreBusy();
        if (trigger) {
          delete trigger.dataset.gbCartBusy;
          trigger.removeAttribute('aria-disabled');
        }
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart add failed');
          return r.json();
        })
        .then(function (response) {
          unlatch();
          var added = lines.reduce(function (n, l) {
            return n + (l.quantity || 1);
          }, 0);
          var event = new Event('cart:update', { bubbles: true });
          event.detail = {
            resource: {},
            sourceId: opts.sourceId || 'gb-cart',
            data: { source: opts.sourceId || 'gb-cart', itemCount: added, sections: response.sections || {} }
          };
          (trigger || document.body).dispatchEvent(event);
          if (opts.navigate === true || (opts.navigate !== false && !document.querySelector('cart-drawer-component'))) {
            window.location.href = '/cart';
          } else if (opts.navigate !== false) {
            if (trigger) {
              var prevLabel = trigger.textContent;
              trigger.textContent = 'Added \u2713';
              setTimeout(function () {
                if (trigger.textContent === 'Added \u2713') trigger.textContent = prevLabel;
              }, 1600);
            }
            // The drawer element can exist before its component hydrates and starts listening.
            setTimeout(function () {
              if (!document.querySelector('cart-drawer-component dialog[open], cart-drawer-component[open]')) {
                window.location.href = '/cart';
              }
            }, 800);
          }
          return { ok: true, sections: response.sections || {} };
        })
        .catch(function () {
          unlatch();
          if (opts.errorEl) opts.errorEl.hidden = false;
          return { ok: false };
        });
    }
  };


  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-gb-cart-busy]').forEach(function (el) {
      delete el.dataset.gbCartBusy;
      el.removeAttribute('aria-disabled');
    });
  });

  // Shared carts: `?gb_cart=` carries each line WITH its properties (the grind), which
  // Shopify's /cart/{id}:{qty} permalinks drop.
  (function () {
    var raw = new URLSearchParams(window.location.search).get('gb_cart');
    if (!raw) return;
    var items;
    try {
      var bin = atob(raw.replace(/-/g, '+').replace(/_/g, '/'));
      var bytes = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      items = JSON.parse(new TextDecoder().decode(bytes));
    } catch (e) {
      return;
    }
    if (!Array.isArray(items)) return;
    var lines = items
      .filter(function (l) { return l && Number(l.id) > 0 && Number(l.quantity) > 0; })
      .slice(0, 50)
      .map(function (l) {
        var line = { id: Number(l.id), quantity: Math.min(Number(l.quantity), 99) };
        // Liquid's `json` writes line properties as [[key, value], …].
        var props = Array.isArray(l.properties)
          ? l.properties.reduce(function (o, kv) {
              if (Array.isArray(kv) && kv.length === 2) o[kv[0]] = kv[1];
              return o;
            }, {})
          : l.properties;
        if (props && typeof props === 'object' && Object.keys(props).length > 0) line.properties = props;
        return line;
      });
    if (lines.length === 0) return;
    // Idempotent: a coffee the cart already holds (same variant AND same properties) is SET to the
    // link's quantity rather than added again, so reopening the link never stacks bags. Anything
    // else in the cart is left alone.
    var sig = function (variantId, props) {
      var p = props || {};
      return variantId + '|' + Object.keys(p).sort().map(function (k) { return k + '=' + p[k]; }).join('&');
    };
    // One entry per coffee+properties, or a link listing it twice would add the sum and then
    // reset to one entry on the next open.
    var merged = {};
    lines.forEach(function (line) {
      var k = sig(line.id, line.properties);
      if (merged[k]) merged[k].quantity = Math.min(merged[k].quantity + line.quantity, 99);
      else merged[k] = line;
    });
    lines = Object.keys(merged).map(function (k) { return merged[k]; });
    var post = function (url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    };
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var byKey = {};
        (cart.items || []).forEach(function (item) { byKey[sig(item.variant_id, item.properties)] = item; });
        var updates = {};
        var fresh = [];
        lines.forEach(function (line) {
          var have = byKey[sig(line.id, line.properties)];
          if (have) {
            if (have.quantity !== line.quantity) updates[have.key] = line.quantity;
          } else {
            fresh.push(line);
          }
        });
        var step = Object.keys(updates).length ? post('/cart/update.js', { updates: updates }) : Promise.resolve();
        return step
          .then(function () {
            if (fresh.length === 0) return 0;
            // /cart/add.js is all-or-nothing: one sold-out coffee would drop the rest. Retry one by one.
            return post('/cart/add.js', { items: fresh }).then(function (r) {
              if (r.ok) return 0;
              return fresh.reduce(function (chain, line) {
                return chain.then(function (skipped) {
                  return post('/cart/add.js', { items: [line] }).then(function (one) { return skipped + (one.ok ? 0 : 1); });
                });
              }, Promise.resolve(0));
            });
          })
          .then(function (skipped) {
            window.location.href = skipped ? '/cart?gb_cart_skipped=' + skipped : '/cart';
          });
      })
      .catch(function () { window.location.href = '/cart'; });
  })();

  // The shared link's coffees that couldn't be added (sold out, or no longer sold): say so once.
  (function () {
    var params = new URLSearchParams(window.location.search);
    var skipped = parseInt(params.get('gb_cart_skipped'), 10);
    if (!(skipped > 0)) return;
    function show() {
      var note = document.createElement('p');
      note.className = 'gb-error gb-shared-skipped';
      note.setAttribute('role', 'alert');
      note.textContent = skipped === 1
        ? 'One coffee from the shared link is no longer available, so it isn\u2019t in your cart.'
        : skipped + ' coffees from the shared link are no longer available, so they aren\u2019t in your cart.';
      var anchor = document.querySelector('.cart__ctas') || document.querySelector('main h1') || document.querySelector('main');
      if (!anchor) return;
      if (anchor.tagName === 'MAIN') anchor.prepend(note);
      else anchor.parentNode.insertBefore(note, anchor.tagName === 'H1' ? anchor.nextSibling : anchor);
      params.delete('gb_cart_skipped');
      var qs = params.toString();
      history.replaceState(history.state, '', window.location.pathname + (qs ? '?' + qs : ''));
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show);
    else show();
  })();
})();
